import { HttpHeaders } from '@angular/common/http';

export class HeadersTool {

  public static getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });
  }

  public static getHeadersWithToken(): HttpHeaders {
    const user = localStorage.getItem('user');

    let token = "";

    if (user) {
      const parsedUser = JSON.parse(user);
      token = parsedUser.token;
    }

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + token
    });
  }

}
